import React from 'react'
import { Link } from 'react-router-dom'
import { FOOTER_EXPLORE, CONTACT_INFO, SITE_LINKS } from '../constants/siteLinks'

const linkStyle = {
  color: '#64748b',
  textDecoration: 'none',
  fontSize: 14,
  transition: 'color 0.3s ease',
}

const socialStyle = {
  width: 36,
  height: 36,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f0f0f0',
  color: '#3490ce',
  borderRadius: '50%',
  textDecoration: 'none',
  fontSize: 14,
}

function SiteFooter() {
  return (
    <footer>
      <div
        className="tv-footer-wrap footer-bg z-index-1"
        style={{ backgroundColor: '#fff', color: '#102a43', paddingTop: 80, paddingBottom: 40 }}
      >
        <div className="container">
          <div className="row mb-60">
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-40">
              <div className="footer-widget">
                <div className="footer-logo mb-20">
                  <Link to={SITE_LINKS.home}>
                    <img src="/assets/img/logo/F_logo.png" alt="Fabritech" style={{ height: 50, width: 'auto' }} />
                  </Link>
                </div>
                <div className="footer-about">
                  <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.8, marginBottom: 0 }}>
                    At Fabritech, we are dedicated to providing top-notch IT solutions and services.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 mb-40">
              <div className="footer-widget">
                <h4 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, color: '#102a43' }}>Explore</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {FOOTER_EXPLORE.map((item) => (
                    <li key={item.href} style={{ marginBottom: 12 }}>
                      <Link
                        to={item.href}
                        style={linkStyle}
                        onMouseEnter={(e) => { e.currentTarget.style.color = '#3490ce' }}
                        onMouseLeave={(e) => { e.currentTarget.style.color = '#64748b' }}
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-40">
              <div className="footer-widget">
                <h4 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, color: '#102a43' }}>Contact Info</h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ marginBottom: 15, display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                    <i className="fa-solid fa-map-marker-alt" style={{ color: '#3490ce', marginTop: 2, minWidth: 16 }} />
                    <a
                      href={CONTACT_INFO.mapsHref}
                      target="_blank"
                      rel="noreferrer"
                      style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, textDecoration: 'none' }}
                    >
                      {CONTACT_INFO.address}
                    </a>
                  </li>
                  <li style={{ marginBottom: 15, display: 'flex', alignItems: 'center', gap: 10 }}>
                    <i className="fa-solid fa-envelope" style={{ color: '#3490ce', minWidth: 16 }} />
                    <a href={CONTACT_INFO.emailHref} style={{ fontSize: 14, color: '#64748b', textDecoration: 'none' }}>
                      {CONTACT_INFO.email}
                    </a>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <i className="fa-solid fa-phone" style={{ color: '#3490ce', minWidth: 16 }} />
                    <a href={CONTACT_INFO.phoneHref} style={{ fontSize: 14, color: '#64748b', textDecoration: 'none' }}>
                      {CONTACT_INFO.phone.replace(/\s/g, '')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-40">
              <div className="footer-widget">
                <h4 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, color: '#102a43' }}>Follow Us</h4>
                <div style={{ display: 'flex', gap: 12 }}>
                  <a href="https://twitter.com" target="_blank" rel="noreferrer" style={socialStyle} aria-label="Twitter">
                    <i className="fa-brands fa-twitter" />
                  </a>
                  <a href="https://www.instagram.com/fabritech_ltd/" target="_blank" rel="noreferrer" style={socialStyle} aria-label="Instagram">
                    <i className="fa-brands fa-instagram" />
                  </a>
                  <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={socialStyle} aria-label="LinkedIn">
                    <i className="fa-brands fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div style={{ borderTop: '1px solid #eee', paddingTop: 30 }}>
            <div className="row">
              <div className="col-12">
                <div className="footer-copyright" style={{ textAlign: 'center' }}>
                  <p style={{ fontSize: 14, color: '#64748b', margin: 0 }}>
                    Fabritech, All rights reserved 2026. Developed by{' '}
                    <span style={{ color: '#3490ce', fontWeight: 600 }}>Maliki NTWALI</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default SiteFooter
